import React from "react";
import Typography from "../Typography";

const Label = ({ htmlFor, children, className = "", required = false, ...props }) => {
  return (
    <Typography
      variant="text2"
      component="label"
      htmlFor={htmlFor}
      className={`font-medium text-text-primary mb-1 block ${className}`}
      {...props}
    >
      {children}
      {required && <span className="text-badge-danger ml-1">*</span>}
    </Typography>
  );
};

export default Label;
